import React from "react";
import { Link } from "react-router-dom";

interface itemMenuProps {
  habilitado: boolean;
  icone: string;
  link: {
    href: string;
    texto: string;
    onClick?: () => void;
  };
  descricao?: string;
  itemDestaque: boolean;
  descricaoMaiuscula: boolean;
}

const ItemMenu = ({
  habilitado,
  icone,
  link,
  descricao,
  itemDestaque,
  descricaoMaiuscula,
}: itemMenuProps) => {
  const isExternal =
    link.href.startsWith("http://") || link.href.startsWith("https://");

  const content = (
    <>
      <div className="menu-de-inscricao__conteudo">
        <div className="menu-de-inscricao__numero-da-categoria">
          <i className={`fal ${icone}`} aria-hidden="true" />
          <span className={"menu-de-inscricao__icone "}>
            <span />
          </span>
        </div>
        <div className="menu-de-inscricao__texto-do-conteudo">
          <h3
            className="menu-de-inscricao__titulo-do-conteudo u-texto-negrito"
            data-test-id={link.texto}
          >
            {link.texto}
          </h3>
          {descricao && (
            <p
              className={`menu-de-inscricao__descricao-do-conteudo ${
                descricaoMaiuscula ? "u-texto-maiusculo" : ""
              }`}
            >
              {descricao}
            </p>
          )}
        </div>
      </div>
      <div className="menu-de-inscricao__icone-direita">
        {habilitado && (
          <i
            className="fal fa-chevron-right fa_cor-secundaria"
            aria-hidden="true"
          ></i>
        )}
      </div>
    </>
  );

  if (!habilitado) {
    return (
      <div
        className={`menu-de-inscricao__item menu-de-inscricao__item_desativado ${
          itemDestaque ? "menu-de-inscricao__item_destaque" : ""
        }`}
      >
        {content}
      </div>
    );
  }

  return isExternal ? (
    <a
      className={`menu-de-inscricao__item ${
        itemDestaque ? "menu-de-inscricao__item_destaque" : ""
      }`}
      href={link.href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={link.onClick}
    >
      {content}
    </a>
  ) : (
    <Link
      className={`menu-de-inscricao__item ${
        itemDestaque ? "menu-de-inscricao__item_destaque" : ""
      }`}
      to={link.href}
      onClick={link.onClick}
    >
      {content}
    </Link>
  );
};

export default ItemMenu;
